import { useState } from 'react';

import { Box, Button, IconButton, ResponsiveDialog, Text } from 'shell/components';

const ResponsiveDialogDemo = () => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <Text variant={'sh1'}>ResponsiveDialog</Text>
            <Button onClick={() => setOpen(true)}>Open Responsive Dialog</Button>
            <ResponsiveDialog open={open} onClose={() => setOpen(false)}>
                <Box>
                    <IconButton kind={'exit'} size={'medium'} variant={'square'} onClick={() => setOpen(false)} />
                    <Text variant={'h6'}>Title</Text>
                    <Text variant={'p2'}>Content</Text>
                </Box>
            </ResponsiveDialog>
        </>
    );
};

export default ResponsiveDialogDemo;
